import {
  GET_PRODUCTINVENTORYBRANCH,
  GET_PRODUCTINVENTORYBRANCH_SUCCESS,
  GET_PRODUCTINVENTORYBRANCH_FAIL,
  DELETE_PRODUCTINVENTORYBRANCH,
  DELETE_PRODUCTINVENTORYBRANCH_SUCCESS,
  DELETE_PRODUCTINVENTORYBRANCH_FAIL,
  UPDATE_PRODUCTINVENTORYBRANCH,
  UPDATE_PRODUCTINVENTORYBRANCH_SUCCESS,
  UPDATE_PRODUCTINVENTORYBRANCH_FAIL,
  ADD_NEW_PRODUCTINVENTORYBRANCH,
  ADD_PRODUCTINVENTORYBRANCH_SUCCESS,
  ADD_PRODUCTINVENTORYBRANCH_FAIL,
  PRODUCTINVENTORYBRANCH_LOADING,
  PRODUCTINVENTORYBRANCH_RESET,
} from "./actionType";

export const resetProductInventoryBranchState = (actionType) => ({
  type: PRODUCTINVENTORYBRANCH_RESET,
  payload: { actionType },
});

export const getProductInventoryBranchSuccess = (actionType, data) => ({
  type: GET_PRODUCTINVENTORYBRANCH_SUCCESS,
  payload: { actionType, data },
});

export const getProductInventoryBranchFail = (actionType, error) => ({
  type: GET_PRODUCTINVENTORYBRANCH_FAIL,
  payload: { actionType, error },
});

export const getProductInventoryBranch = data => ({
  type: GET_PRODUCTINVENTORYBRANCH,
  payload: data,
});

export const getProductInventoryBranchLoading = () => ({
  type: PRODUCTINVENTORYBRANCH_LOADING
});

export const deleteProductInventoryBranch = data => ({
  type: DELETE_PRODUCTINVENTORYBRANCH,
  payload: data,
});

export const deleteProductInventoryBranchSuccess = data => ({
  type: DELETE_PRODUCTINVENTORYBRANCH_SUCCESS,
  payload: data,
});

export const deleteProductInventoryBranchFail = error => ({
  type: DELETE_PRODUCTINVENTORYBRANCH_FAIL,
  payload: error,
});

export const updateProductInventoryBranch = data => ({
  type: UPDATE_PRODUCTINVENTORYBRANCH,
  payload: data,
});

export const updateProductInventoryBranchFail = error => ({
  type: UPDATE_PRODUCTINVENTORYBRANCH_FAIL,
  payload: error,
});

export const updateProductInventoryBranchSuccess = data => ({
  type: UPDATE_PRODUCTINVENTORYBRANCH_SUCCESS,
  payload: data,
});

export const addNewProductInventoryBranch = data => ({
  type: ADD_NEW_PRODUCTINVENTORYBRANCH,
  payload: data,
});

export const addProductInventoryBranchSuccess = data => ({
  type: ADD_PRODUCTINVENTORYBRANCH_SUCCESS,
  payload: data,
});

export const addProductInventoryBranchFail = error => ({
  type: ADD_PRODUCTINVENTORYBRANCH_FAIL,
  payload: error,
});